import { ReactNode } from "react";
import { WrappedFieldInputProps, WrappedFieldMetaProps } from "redux-form";

export interface Option<T = string | number> {
  label: string;
  value: T;
}

export type EnhancedOptionValue = string | number;

export type EnhancedOptionLabel = string | number | ReactNode;

export interface EnhancedOption<
  V = EnhancedOptionValue,
  L = EnhancedOptionLabel
> {
  value: V;
  label: L;
  textSearchValue?: string;
  options?: EnhancedOption<V, L>[];
}

export interface DropdownOption {
  label: string;
  value: any;
  options?: Option[];
}

export interface MultiSelectOption extends DropdownOption {
  isDisabled?: boolean;
  isOrderedMultiselect?: boolean;
  unselectable?: boolean;
  renderCustomOption?: (loadAsyncOptions: () => void) => JSX.Element;
}

export enum AsyncOptionsPositions {
  Top = "top",
  Bottom = "bottom",
}

export enum OptionDropdownPosition {
  Top = "top",
  Bottom = "bottom",
}

export interface MultiSelectProps {
  canCheckAll?: boolean;
  defaultToAll?: boolean;
  disabled?: boolean;
  formatText?: (
    value: any[],
    checkAll: boolean,
    options: MultiSelectOption[]
  ) => string;
  input: WrappedFieldInputProps;
  id?: string;
  isClearable?: boolean;
  isLoading?: boolean;
  isSearchable?: boolean;
  label?: string;
  margin?: string;
  meta: WrappedFieldMetaProps;
  normalizeValues?: (values: any) => any;
  checkBoxClickHandler?: (e: any) => void;
  options: MultiSelectOption[];
  placeholder?: string;
  reinitializeKey?: any;
  loadAsyncOptions?: () => Promise<MultiSelectOption[]>;
  cachedAsyncOptions?: DropdownOption[];
  fitContentWidth?: boolean;
  minWidth?: string;
  maxWidth?: string;
  asyncOptionsPosition?: AsyncOptionsPositions;
  optionDropdownPosition?: OptionDropdownPosition;
  noOptionsMessage?: string;
  noWrap?: boolean;
  onChange?: (value: any) => void;
  checkedOptionsFirst?: boolean;
  keepOverlayOpen?: any;
  menuPosition?: string;
  hasApplyButton?: boolean;
}
